// extracted by mini-css-extract-plugin
module.exports = {"card":"OccasionCard_card__hyPcp","emoji":"OccasionCard_emoji__AgzOh","title":"OccasionCard_title__oWk_m","message":"OccasionCard_message__t18mz"};